// Plato doctor code -> display name.
//
// Reverse of SPECIALIST_TO_PLATO_CODE in
// supabase/functions/plato-waitlist-push/index.ts (source:
// GET /appointment/calendars, verified 2026-05-27). Plato appointments carry
// only the short provider code, so UI surfaces (Daily List, Visit history)
// map it back to a readable doctor name and fall back to the raw code for
// anything unknown.
export const PLATO_DOCTOR_NAMES: Record<string, string> = {
  // TCENDO (Forum)
  RA: 'Dr Richard Ang',
  GL: 'Dr Gerald Lim Kian Chong',
  SHK: 'Dr Soo Hyung Kim',
  RF: 'Dr Renee Fan Yuehong',
  SR: 'Dr Surein Angamuthu',
  SZSH: 'Dr Susan Han',
  BS: 'Dr Baldev Singh',
  SL: 'Dr Shermin Lee',
  // SSD (Ngee Ann)
  LT: 'Dr Liane Teo',
  JF: 'Dr Jacqueline Feng',
  TL: 'Dr Tammy Low Li-Zhuang',
  BQXJ: 'Dr Jasmine Boey',
  LWQ: 'Dr Loke Weiqiang',
  BC: 'Dr Bertrand Chew Shen Hui',
  HWN: 'Dr Ho Wennee',
  JL: 'Dr Lim Teong Joe',
};

/**
 * Maps a Plato doctor code to a display name, falling back to the raw code
 * (e.g. an unmapped provider or the synthetic "Unassigned" bucket).
 */
export const getPlatoDoctorName = (code: string): string => {
  const cleaned = (code || '').trim();
  if (!cleaned) {
    return 'Unassigned';
  }
  return PLATO_DOCTOR_NAMES[cleaned.toUpperCase()] ?? cleaned;
};
